// Convert DynamoDB format to clean JSON
export const convertDynamoDBToJSON = (items) => {
    if (!items || !Array.isArray(items)) return [];

    return items.map(item => {
        const cleanItem = {};

        for (const [key, value] of Object.entries(item)) {
            // Handle different DynamoDB data types
            if (value.S !== undefined) {
                cleanItem[key] = value.S; // String
            } else if (value.N !== undefined) {
                cleanItem[key] = value.N; // Number
            } else if (value.BOOL !== undefined) {
                cleanItem[key] = value.BOOL; // Boolean
            } else if (value.L !== undefined) {
                cleanItem[key] = value.L.map(v => v.S || v.N || v); // List
            } else if (value.M !== undefined) {
                cleanItem[key] = convertDynamoDBToJSON([value.M])[0]; // Map
            } else if (value.SS !== undefined) {
                cleanItem[key] = value.SS; // String Set
            } else if (value.NS !== undefined) {
                cleanItem[key] = value.NS; // Number Set
            } else {
                cleanItem[key] = value;
            }
        }

        return cleanItem;
    });
};

